import type { LevelData } from '../level/LevelData';
import type { BoardTutorial } from '../tutorials/board/types';
import plankBlockerTutorialJSON from '../../../levels/boardTutorials/tutorial_plank_blocker.json';

export enum BlockerIntroType {
  LockedTiles = 'lockedTiles',
  LockedStacks = 'lockedStacks',
  Planks = 'planks',
  TapedStacks = 'tapedStacks',
  Knots = 'knots',
  BirdHouse = 'birdHouse',
  Stars = 'stars',
  Rockets = 'rockets',
  MeasureTape = 'measureTape',
  ColorPlanks = 'colorPlanks',
}

export interface BlockerIntroConfig {
  icon: string;
  title: string;
  description: string;
  tutorialData?: BoardTutorial;
}

export const BLOCKER_INTRO_CONFIG_MAP: Record<BlockerIntroType, BlockerIntroConfig> = {
  [BlockerIntroType.Planks]: {
    icon: 'Blocker_Intro_Plank',
    title: 'Planks<br>$Unlocked!$',
    description: 'Clear a Stack next to a $Plank$ to $break it!$',
    tutorialData: {
      levelData: plankBlockerTutorialJSON as unknown as LevelData,
      steps: [
        {
          caption: 'Clear stacks next to Plank Blockers to remove them.',
          startDelay: 0,
          endDelay: 0,
          movement: {
            trayX: 0,
            stackX: 0,
            stackY: 1,
            waitUntilComplete: false,
          },
        },
        {
          startDelay: 1000,
          endDelay: 1700,
          movement: {
            trayX: 1,
            stackX: 2,
            stackY: 2,
            waitUntilComplete: true,
          },
        },
      ],
    },
  },
  [BlockerIntroType.LockedTiles]: {
    icon: 'Blocker_Intro_Locked_Tile',
    title: 'Locked Stacks<br>$Unlocked!$',
    description: 'Clear Tiles to $break the Locks$!',
  },
  [BlockerIntroType.LockedStacks]: {
    icon: 'Blocker_Intro_Locked_Stack',
    title: 'Locked Tiles<br>$Unlocked!$',
    description: 'Clear Tiles to $break the Locks$!',
  },
  [BlockerIntroType.TapedStacks]: {
    icon: 'Blocker_Intro_Taped_Stack',
    title: 'Taped Stack<br>$Unlocked!$',
    description: 'Clear a Stack next to the $Tape$ to $remove it!$',
  },
  [BlockerIntroType.Knots]: {
    icon: 'Blocker_Intro_Taped_Knot',
    title: 'Knots<br>$Unlocked!$',
    description: 'Clear a Stack next to a $Knot$ to $untie it!$',
  },
  [BlockerIntroType.BirdHouse]: {
    icon: 'Blocker_Intro_Bird_House',
    title: 'Bird House<br>$Unlocked!$',
    description: 'Clear a Stack next to a Bird House to $collect$ a $Bird$!',
  },
  [BlockerIntroType.Stars]: {
    icon: 'Blocker_Intro_Star',
    title: 'Stars<br>$Unlocked!$',
    description: 'Clear a Stack with a Star to $collect that Star$!',
  },
  [BlockerIntroType.Rockets]: {
    icon: 'Blocker_Intro_Rockets',
    title: 'Rockets<br>$Unlocked!$',
    description: 'Clear a Stack next to $Rockets$ to $set one off!$',
  },
  [BlockerIntroType.ColorPlanks]: {
    icon: 'Blocker_Intro_Color_Planks',
    title: 'Colour Planks<br>$Unlocked!$',
    description: 'Clear a Stack of a matching colour next to a $Colour Plank$ to $break it!$',
  },
  [BlockerIntroType.MeasureTape]: {
    icon: 'Blocker_Intro_Measuring_Tape',
    title: 'Measuring Tape<br>$Unlocked!$',
    description: 'Clear a Stack next to any part of the $Measuring Tape$ to $retract it$!',
  },
};
